import { Directive, EventEmitter, Injectable, Output } from '@angular/core';
import { ProfileChangeObject } from './models/profile-change-event';
import { ProfileObject } from './models/profile-object';
import CryptoJS from 'crypto-js';


@Directive()
@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  @Output() onProfileChange: EventEmitter<ProfileChangeObject> = new EventEmitter<ProfileChangeObject>();
  @Output() onIsAlmostExpired: EventEmitter<boolean> = new EventEmitter<boolean>();
  private _token: string = null;
  private set token(token: string) {
    this._token = token;
  }
  private get token(): string {
    return this._token;
  }
  private _expires: string = null;
  private set expires(date: string) {
    this._expires = date;
  }
  private get expires(): string {
    return this._expires;
  }
  private profile: ProfileObject = null;
  private properties: string[] = ['id', 'username', 'name', 'companyName', 'companyId', 'idPerfil', 'tokenIvSign', 'areas', 'refresh_token', 'color'];

  constructor() { }

  init(): void {
    const token = this.retrieveToken();
    const event: ProfileChangeObject = {
      status: false,
      logout: false,
      value: null
    };

    if (!token) {
      this.onProfileChange.emit(event);

      return;
    }
    let data;
    try {
      data = JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('user'), 'ttW17j3r48qLs6O').toString(CryptoJS.enc.Utf8))
    } catch (error) {
      data = JSON.parse(localStorage.getItem('user'));
    }
    if (!data) {
      this.onProfileChange.emit(event);

      return;
    }
    this.token = token;
    this.expires = document.cookie.replace(/(?:(?:^|.*;\s*)expires\s*\=\s*([^;]*).*$)|^.*$/, '$1');
    this.setUser(data, true);
  }

  /**
   * Sets the user properties processing the data passed
   * @param {ProfileObject} data Object with properties that should be set
   * @param {boolean} skipSave Skips saving the user data to localStorage
   */
  setUser(data: ProfileObject, skipSave?: boolean): void {
    if (!data) {
      //  this.removeUser();

      return;
    }

    if (!skipSave) {
      this.token = data.access_token;
      this.expires = data.expires;
      document.cookie = 'access_token=' + this.token + ';path=/;';
      document.cookie = 'expires=' + this.expires + ';path=/;';
      document.cookie = 'companyName=' + data.companyName + ';path=/;';
    }

    this.profile = {};
    for (const key of this.properties) {
      const value = data[key];
      if (value) {
        this.setUserProperty(key, value);
      }

    }

    const event: ProfileChangeObject = {
      status: true,
      logout: false,
      value: this.profile
    };
    if (!skipSave) {
      localStorage.setItem('user', CryptoJS.AES.encrypt(JSON.stringify(this.profile), 'ttW17j3r48qLs6O').toString());
    }
    this.onProfileChange.emit(event);
    this.setTimer();
  }

  removeUser(): void {
    this.profile = null;
    this.token = null;
    this.expires = null;
    if (document.cookie) {
      document.cookie = 'access_token=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
      document.cookie = 'expires=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
    }
    if (document.body.hasAttribute('style')) {
      document.body.removeAttribute('style');
    }
    const orgaidform = localStorage.getItem('orgaidform') === null ? null : localStorage.getItem('orgaidform');
    localStorage.clear();
    sessionStorage.clear();
    if (orgaidform) { localStorage.setItem('orgaidform', orgaidform); }
    const event: ProfileChangeObject = {
      status: false,
      logout: true,
      value: null
    };
    this.onProfileChange.emit(event);
  }

  setUserProperty(key: string, value: any): void {
    if (this.profile) {
      this.profile[key] = value;
    }
    localStorage.setItem('user', CryptoJS.AES.encrypt(JSON.stringify(this.profile), 'ttW17j3r48qLs6O').toString());

    const event: ProfileChangeObject = {
      status: true,
      logout: false,
      value: this.profile
    };
    this.onProfileChange.emit(event);
  }

  removeUserProperty(key: string): void {
    this.setUserProperty(key, null);
  }

  getUser(): ProfileObject {
    return this.profile;
  }

  setUserProfile(): void {
    const user = this.getUser();
    if(!document.cookie.includes('profileType=')){
      document.cookie = 'profileType=' + user.idPerfil + ';path=/;';
    }
  }

  getToken(): string {
    return this.token ? 'Bearer ' + this.token : null;
  }

  /**
   * Retrieves token that should be used on API methods that can be called whitout user being logged
   * ('1' when user is not logged, to avoid error of not having Authorization parameter)
   * @returns {string} Token for the API requests from the public part of the platform
   */
  getPublicToken(): string {
    return this.token ? 'Bearer ' + this.token : '1';
  }

  getUserProperty(key: string): any {
    if (!this.profile) {
      return null;
    }

    return this.profile[key];
  }

  private retrieveToken() {
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)access_token\s*\=\s*([^;]*).*$)|^.*$/, '$1');
    const expires = document.cookie.replace(/(?:(?:^|.*;\s*)expires\s*\=\s*([^;]*).*$)|^.*$/, '$1');
    if (!token) {
      return;
    }

    if (this.isExpired(expires)) {
      this.removeUser();

      return;
    }

    return token;
  }

  private isExpired(expires?: string): boolean {

    if (!expires) {
      expires = this.expires;
    }

    return !expires || new Date(expires) < new Date();
  }

  private isAlmostExpired(): boolean {
    if (!this.profile) {
      return true;
    }
    const expires = this.expires;

    return !expires || new Date() > new Date(new Date(expires).getTime() - (300000));
  }

  private setTimer() {
    const _this = this;
    const interval = setInterval(() => {
      if (this.isExpired()) {
        _this.removeUser();
        clearInterval(interval);
      } else if (this.isAlmostExpired()) {
        this.onIsAlmostExpired.emit(true);
      }
    }, 60000);
  }

  getUserPropertyKeys() {
    return this.properties;
  }

}
